// src/pages/AddNewCustomer.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './AddNewCustomer.scss';
import Api from '../../Network/ApiConfig'; // Added Api import
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'; // Added for phone number parsing
import { useHistory }  from "react-router-dom";
import { message } from 'antd'; // Added for displaying messages

export default function AddNewCustomer() {
  const [form, setForm] = useState({
    FullName: '',
    fullPhoneNumber: '', // Will store E.164 formatted number
    Email: '',
  });
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalOk = () => {
    setIsModalVisible(false);
    setForm({ FullName: '', fullPhoneNumber: '', Email: '' }); // Reset form
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({
      ...f,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const phoneNumber = form.fullPhoneNumber ? parsePhoneNumberFromString(form.fullPhoneNumber) : null;
      const apiPayload = {
        FullName: form.FullName,
        Email: form.Email,
        PhoneNumber: phoneNumber ? phoneNumber.nationalNumber : '',
        PhoneKey: phoneNumber ? `+${phoneNumber.countryCallingCode}` : '',
      };

      const response = await Api.post('Business/AddCustomer', apiPayload);

      if (response.data) { // Assuming response.data indicates success
        setIsSuccess(true);
        setIsModalVisible(true);
        setForm({ FullName: '', fullPhoneNumber: '', Email: '' }); // Reset form
        message.success('Customer added successfully!');
        history.push({
          pathname: "/add-order",
        });
      }
      else{
        message.error(response?.message || 'Failed to add customer');
      }
      
    } catch (error) {
      console.error('Error adding customer:', error);
      // You might want to show an error message to the user here
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-new-customer-page">
      <div className="form-container">
        <h2>Add New Customer</h2>

        <form onSubmit={handleSubmit}>
         

          <div className="form-group">
            <input
              type="text"
              name="FullName"
              placeholder="Full Name"
              value={form.FullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <PhoneInput
              international
              defaultCountry="AE"
              value={form.fullPhoneNumber}
              onChange={(value) => setForm(prev => ({ ...prev, fullPhoneNumber: value }))}
              className="phone-input"
              required
              displayInitialValue
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="Email"
              placeholder="Email"
              value={form.Email}
              onChange={handleChange}
              required
            />
          </div>

          
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginTop: "1rem",
                marginBottom: "0.5rem",
                fontSize: "1.8rem",
                color: "#555",
                lineHeight: 1.5,
              }}
            >
              <strong style={{ minWidth: 60, fontSize: "2.1rem" , fontWeight:700, marginTop: "-3px"}}>Note:</strong>
              <span>
                Once the customer is registered, their username and password will be sent to the registered email address.
              </span>
            </div>

          <br></br>
          <button
            type="submit"
            className="submit-button"
            disabled={isLoading}
          >
            {isLoading ? 'Adding Customer...' : 'Add New Customer'}
          </button>
        </form>

        {isSuccess && (
          <Modal
            // title="Success"
            open={isModalVisible}
            onOk={handleModalOk}
            okText="OK"
            style={{ textAlign: 'center' }}
            footer={[
              <button key="ok" onClick={handleModalOk} className="ant-btn ant-btn-primary">
                OK
              </button>
            ]}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '1rem',flexDirection:'column' }}>
              <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '5rem' }} />
              <span>Customer added successfully!</span>
            </div>
          </Modal>
        )}

      </div>
    </div>
  )
}
